import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../../e-met/services/data.service';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.scss'],
})
export class DocumentsComponent implements OnInit {
    @Input() data: any;

    constructor(private dataService: DataService) {}

    ngOnInit(): void {}

    documentAction(appId, id) {
        this.dataService.getContractDocuments(appId, id).subscribe(
            (response) => {
                this.dataService.showFileInNewTab(response.body);
            },
            (error) => {
                console.log('error');
            }
        );
    }


    clickHandler(methodName: string, arg: any){
      if (typeof this[methodName] === 'function') {
        this[methodName](arg);
      }
    }

    downloadTemplate(appId){
      this.dataService.getTemplateDoc(appId);
    }


}
